'use strict';

require('../../styles/vars-fallback.pcss');